export default __webpack_public_path__ + "static/media/program_list_img01.9a6f741d.jpg";